<button
  class="p-2 bg-sidebar rounded-md mt-2 hover:bg-header dark:bg-dark-header hover:text-white transition-colors duration-150 text-header"
  (click)="openModal()">
  <lucide-icon name="pin" class="lucide lucide-pin rotate-45 hover:rotate-0 h-5 w-5"></lucide-icon>

</button>
